import React from 'react'
import { useNavigate } from 'react-router-dom'
import ProjectImg1 from '../assets/images/projects/projects1.jpg'
import ProjectImg2 from '../assets/images/projects/projects2.jpg'
import ProjectImg3 from '../assets/images/projects/projects3.jpg'
import ProjectImg4 from '../assets/images/projects/projects4.jpg'
import ProjectImg5 from '../assets/images/projects/projects5.jpg'
import ProjectImg6 from '../assets/images/projects/projects6.jpg'
import ProjectImg7 from '../assets/images/projects/projects7.jpg'
import ProjectImg8 from '../assets/images/projects/projects8.jpg'
import ProjectImg9 from '../assets/images/projects/projects9.jpg'
import FixHeader from '../component/FixHeader'
import Loader from '../component/Loader'
import ClientsSaySlider from '../component/ClientsSaySlider'
import LatestBlog from '../component/LatestBlog'
import Footer from '../component/Footer'


const Project3 = () => {
    const navigate = useNavigate()
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Project Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="project-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Projects</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/Project3")}>Projects</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/Project3")}>Projects 3</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Project Section Two ===================================== --> */}
            <section className="about-section-two overflow-hidden">
                <div className="container">
                    <h2 className=" section-heading-text latestProjects-heading" data-aos="fade-up"><span>Content Writing</span>
                        Projects</h2>
                    <p className="section-sub-text pharetra urna" data-aos="fade-up">Hendrerit facilisi habitasse arcu urna
                        bibendum. Cursus in mattis nunc pretium amet dignissim.</p>
                    <div className="row project-page2-row">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="project-card" onClick={() => navigate("/ProjectDetails1")}>
                                <img src={ProjectImg1} alt="projects1" />
                                <div className="hover-area">
                                    <div className="project-card-body">
                                        <h2 className="profile-title">Homely Real Estate</h2>
                                        <p className="profile-designation">Web Copy Writer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="project-card" onClick={() => navigate("/ProjectDetails2")}>
                                <img src={ProjectImg2} alt="projects2" />
                                <div className="hover-area">
                                    <div className="project-card-body">
                                        <h2 className="profile-title">Crypti App</h2>
                                        <p className="profile-designation">Video Script Writer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="project-card" onClick={() => navigate("/ProjectDetails3")}>
                                <img src={ProjectImg3} alt="projects3" />
                                <div className="hover-area">
                                    <div className="project-card-body">
                                        <h2 className="profile-title">24Times News</h2>
                                        <p className="profile-designation">Blog Content Writer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="project-card" onClick={() => navigate("/ProjectDetails1")}>
                                <img src={ProjectImg4} alt="projects4" />
                                <div className="hover-area">
                                    <div className="project-card-body">
                                        <h2 className="profile-title">Mobiza Mobile</h2>
                                        <p className="profile-designation">Digital Copy Writer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="project-card" onClick={() => navigate("/ProjectDetails2")}>
                                <img src={ProjectImg5} alt="projects5" />
                                <div className="hover-area">
                                    <div className="project-card-body">
                                        <h2 className="profile-title">Jecky Grocery</h2>
                                        <p className="profile-designation">Brochure Copy Writer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="project-card" onClick={() => navigate("/ProjectDetails3")}>
                                <img src={ProjectImg6} alt="projects6" />
                                <div className="hover-area">
                                    <div className="project-card-body">
                                        <h2 className="profile-title">Blogging SEO</h2>
                                        <p className="profile-designation">Writer</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="project-card" onClick={() => navigate("/ProjectDetails1")}>
                                <img src={ProjectImg7} alt="projects7" />
                                <div className="hover-area">
                                    <div className="project-card-body">
                                        <h2 className="profile-title">Technical Writing</h2>
                                        <p className="profile-designation">Fluency</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="project-card" onClick={() => navigate("/ProjectDetails2")}>
                                <img src={ProjectImg8} alt="projects8" />
                                <div className="hover-area">
                                    <div className="project-card-body">
                                        <h2 className="profile-title">Amigo App</h2>
                                        <p className="profile-designation">App</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6" data-aos="fade-up">
                            <div className="project-card" onClick={() => navigate("/ProjectDetails3")}>
                                <img src={ProjectImg9} alt="projects9" />
                                <div className="hover-area">
                                    <div className="project-card-body">
                                        <h2 className="profile-title">Back Link</h2>
                                        <p className="profile-designation">Fluency</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ClientsSaySlider />
            <LatestBlog />
            <Footer />
        </>
    )
}
export default Project3